<template>
    <ContentPage title="Cennik - Kupujący">
        <div>
            <p>
                O ile pisemnie nie uzgodniono inaczej lub nie określono w szczegółowych warunkach aukcji, prowizje należne Fleequid od kupującego za
                sprzedaż każdego pojazdu przeprowadzoną za pośrednictwem Marketplace lub usług i systemów sprzedażowych Fleequid są następujące:
            </p>
        </div>

        <div class="mx-auto flex flex-col items-center gap-2">
            <div>
                <SaleFeesInfoTable />
            </div>
        </div>

        <div>
            <p><strong>*</strong> bez VAT</p>
            <p><strong>**</strong> + plus VAT, jeśli dotyczy</p>
        </div>

        <div>
            <p class="mb-1 font-bold">Przykład 1:</p>
            <p>Cena rozliczeniowa: 6.000&nbsp;€ +&nbsp;VAT</p>
            <p>
                Opłata należna Fleequid od Kupującego: <br class="md:hidden" />
                <span class="font-medium">
                    250&nbsp;€ +&nbsp;(6.000&nbsp;€ * 8,75%) =
                    <span class="whitespace-nowrap">775&nbsp;€ +&nbsp;VAT</span>
                </span>
            </p>
        </div>

        <div>
            <p class="mb-1 font-bold">Przykład 2:</p>
            <p>Cena rozliczeniowa: 180.000&nbsp;€ +&nbsp;VAT</p>
            <p>
                Opłata należna Fleequid od Kupującego: <br class="md:hidden" />
                <span class="font-medium">
                    250&nbsp;€ +&nbsp;(100.000&nbsp;€ * 8,75%) +&nbsp;(80.000&nbsp;€ * 3,75%) =
                    <span class="whitespace-nowrap">12.000&nbsp;€ +&nbsp;VAT</span>
                </span>
            </p>
        </div>
    </ContentPage>
</template>
